
export const formatMoney = (n: number, decimals: number = 2) =>
    `€ ${(Math.round(n * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals)}`
